import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SchoolFpgVO } from 'src/app/shared/models/SchoolFpgVO';
import { FomrSchoolFpg } from 'src/app/shared/models/FormSchoolFpg';
import { State } from 'src/app/shared/models/State';
import { ChurchAdressVO } from 'src/app/shared/models/ChurchAdressVO';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { Wstype } from 'src/app/shared/models/Wstype';
import * as moment from 'moment';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { SchoolFPGWrpVO } from 'src/app/shared/models/SchoolFPGWrpVO';
import { Store } from 'src/app/shared/models/Store';
import { TranslateService } from '@ngx-translate/core';
import { TovpilLangService } from 'src/app/utils/tovpil-lang.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { Constants } from 'src/app/shared/vo/Constants';


@Component({
  selector: 'app-schoolfpg-detail',
  templateUrl: './schoolfpg-detail.component.html',
  styleUrls: ['./schoolfpg-detail.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SchoolfpgDetailComponent implements OnInit {

  /** Generals */
  currentUser: any;
  security: SecurityDocument;
  schoolFpgDetail: any = null;
  dataParent: any;
  profileUser: any;
  device: string;

  /** LABELS */
  translations: Record<string, string> = {};


  /** Form Register School FPG */
  selectedName: string;

  selectedState: State;
  listState: State[];

  listChurchs: ChurchAdressVO[];
  selectedChurch: ChurchAdressVO;
  filteredChurchs: ChurchAdressVO[];
  listStore: Store[];
  selectedStore: Store;

  selectedYear: number;
  selectedPeriod: number;

  listLanguage: ValuesVO[];
  selectedLanguage: ValuesVO;

  listSchoolType: Wstype[];
  selectedSchoolType: Wstype = null;
  visibleMateGuide: boolean;
  sessNum: string;
  sessNum01: string;
  sessNum02: string;
  sessNum03: string;

  startTime: Date;
  endTime: Date;

  selectedGuideStore1: GuideModel;
  listGuidesStore1: GuideModel[];

  selectedGuideStore2: GuideModel;
  listGuidesStore2: GuideModel[];

  startDateStage1: Date;
  endDateStage1: Date;
  status1: string;
  wrksId1: string;

  startDateStage2: Date;
  endDateStage2: Date;
  status2: string;
  wrksId2: string;

  startDateStage3: Date;
  endDateStage3: Date;
  status3: string;
  wrksId3: string;

  planedDate: Date;

  registerFutureGuide: string;
  firstStageFutureGuide: string;
  secondStageFutureGuide: string;
  thirdStageFutureGuide: string;
  lstColsStage: { header: string; }[];
  lstValuesStage: { stageNum: string; startDate: Date; endDate: Date; status: string; wrksId: string }[];


  epgDuration: number = 180;
  datePipe: any;
  canEditComponent: boolean = true;
  currentYear: number;
  minDate: Date;
  maxDate: Date;

  /**
   * This is a constructor function that initializes various services and retrieves data from the
   * previous navigation state.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success or error messages.
   * @param {ConfirmationService} confirmationService - The ConfirmationService is a service provided by
   * the PrimeNG library that allows for displaying confirmation dialogs to the user. It can be used to
   * confirm actions before they are executed, such as deleting a record or submitting a form.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {Router} router - The router is a service provided by Angular that allows for navigation
   * between different components and views within an application. It is used to navigate to different
   * routes and pass data between them.
   * @param {AuthenticationService} authenticationService - This parameter is likely a service that
   * handles user authentication and authorization. It may contain methods for logging in, logging out,
   * and checking user permissions.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the TOVPIL application. It is likely used to perform common tasks such as formatting
   * data, validating input, or handling errors.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private tovpilLang: TovpilLangService,
    private translationService: TovpilLanguageService,
    public translate: TranslateService,
    public primeNGConfig: PrimeNGConfig) {
      const navigation = this.router.getCurrentNavigation();
      this.dataParent = navigation.extras.state as any;
      this.currentYear = new Date().getFullYear();
  }


  /**
   * The ngOnInit function initializes component properties and retrieves security information.
   */
  async ngOnInit() {

    if (Constants.selStore) {
      this.selectedStore = Constants.selStore;
      this.getStatesByCountry();
    }


    // Puede editar el componente solo al crearse
    if (this.dataParent.eppg == null)
      this.canEditComponent = false;

    if (this.dataParent) {
      this.security = this.dataParent.security;

      this.schoolFpgDetail = this.dataParent.eppg;

      // Aqui llega el objeto escuela por parametro, verificamos que no sea flujo 'CREATE'
      if (this.schoolFpgDetail != null) {
        const storeId = this.schoolFpgDetail.schoolFPG.storeId;     // IDENTIFICADOR UNICO PARA MS OBTIENE ESCUELAS
        const schoolId = this.schoolFpgDetail.schoolFPG.schoolId;   // IDENTIFICADOR UNICO DE ESCUELA 

        const schoolFpgDetailTmp = await this.getSchoolFpgAndFilterSelected(storeId, schoolId); // OBTENEMOS ESCUELA | NULL

        this.schoolFpgDetail = schoolFpgDetailTmp != null ? schoolFpgDetailTmp : this.schoolFpgDetail; // ACTUALIZAMOS O DEJAMOS IGUAL

      }
      this.getGuideProfileServices();

    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
    this.getSecurity();
    if (!this.schoolFpgDetail) {
      this.getPeriodToday();
    }
  }


  async getSchoolFpgAndFilterSelected(storeId: string, schoolId: string) {
    let schoolTmp = null;

    try {
      const schools = await this.apiService.getAllSchoolFpg({ "storeId": storeId });

      schoolTmp = schools.find((school) =>
        school.schoolFPG && school.schoolFPG.schoolId === schoolId
      );
    } catch (error) {
      console.error("Error al obtener los datos de la escuela fpg (revise servicio):", error);
    }
    return schoolTmp;
  }


  /** Generals Functions */

  /**
   * This function redirects the user to the "workshops" page in a TypeScript application.
   */
  redirectSchoolList() {
    let navigationExtras: NavigationExtras = {
    }
    this.router.navigate(['catalogs/schoolfpg'], navigationExtras);
  }

  /**
   * This function retrieves security information and translates labels if necessary.
   */
  async getSecurity() {

    if (!this.security) {
      await this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        async data => {

          this.security = data;
          this.tovpilLang.translate(this.security.language);

          await this.getTranslatedLabels();

          this.listDependetLocalStores();
          this.getLanguages();

        });
    } else {
      this.tovpilLang.translate(this.security.language)
      await this.getTranslatedLabels();
      this.listDependetLocalStores();
      this.getLanguages();
    }
  }

  /**
   * The function checks if a variable is not null before executing any code.
   */
  loadDataDetail() {
    if (this.schoolFpgDetail != null) {

      this.selectedName = this.schoolFpgDetail.schoolFPG.name;
      this.selectedYear = +this.schoolFpgDetail.schoolFPG.year;
      this.selectedPeriod = +this.schoolFpgDetail.schoolFPG.period;
      this.registerFutureGuide = this.schoolFpgDetail.enrollNum;
      this.sessNum01 = this.schoolFpgDetail.sessST01;
      this.sessNum02 = this.schoolFpgDetail.sessST02;
      this.sessNum03 = this.schoolFpgDetail.sessST03;

      this.planedDate = this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.schoolFPG.planedDate);
      this.startTime = this.tovpilUtils.convertStringToDateTime(this.schoolFpgDetail.schoolFPG.fromTime);
      this.onSelectInitialTime();

      this.startDateStage1 = this.schoolFpgDetail.wrks01 != null ? this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.wrks01.f0.strDate) : null;
      this.endDateStage1 = this.schoolFpgDetail.wrks01 != null ? this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.wrks01.f0.endDate) : null;
      this.status1 = this.schoolFpgDetail.schoolFPG.wrksId01 != null ? this.schoolFpgDetail.wrks01.wrkStatName : '';
      this.wrksId1 = this.schoolFpgDetail.schoolFPG.wrksId01;

      this.startDateStage2 = this.schoolFpgDetail.wrks02 != null ? this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.wrks02.f0.strDate) : null;
      this.endDateStage2 = this.schoolFpgDetail.wrks02 != null ? this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.wrks02.f0.endDate) : null;
      this.status2 = this.schoolFpgDetail.schoolFPG.wrksId02 != null ? this.schoolFpgDetail.wrks02.wrkStatName : '';
      this.wrksId2 = this.schoolFpgDetail.schoolFPG.wrksId02;

      this.startDateStage3 = this.schoolFpgDetail.wrks03 != null ? this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.wrks03.f0.strDate) : null;
      this.endDateStage3 = this.schoolFpgDetail.wrks03 != null ? this.tovpilUtils.convertStringToDate(this.schoolFpgDetail.wrks03.f0.endDate) : null;
      this.status3 = this.schoolFpgDetail.schoolFPG.wrksId03 != null ? this.schoolFpgDetail.wrks03.wrkStatName : '';
      this.wrksId3 = this.schoolFpgDetail.schoolFPG.wrksId03;

      this.firstStageFutureGuide = this.schoolFpgDetail.wrks01 != null ? this.schoolFpgDetail.wrks01.partN2s : '';
      this.secondStageFutureGuide = this.schoolFpgDetail.wrks02 != null ? this.schoolFpgDetail.wrks02.partN2s : '';
      this.thirdStageFutureGuide = this.schoolFpgDetail.wrks03 != null ? this.schoolFpgDetail.wrks03.partN2s : '';

      this.getLstCols();
    }

  }

  /**
 * The function sets the values of an array of objects representing columns for a table.
 */
  getLstCols() {
    this.lstColsStage = [
      { header: this.translations.lbl_workshops_stages },
      { header: this.translations.lbl_id },
      { header: this.translations.lbl_starting_date },
      { header: this.translations.lbl_ending_date },
      { header: this.translations.lbl_status },
      { header: ' ' },
    ];
    //console.log(this.translations.lbl_stage);
    this.lstValuesStage = [
      { stageNum: this.translations.lbl_stage + ' 1', startDate: this.startDateStage1, endDate: this.endDateStage1, status: this.status1, wrksId: this.wrksId1 },
      { stageNum: this.translations.lbl_stage + ' 2', startDate: this.startDateStage2, endDate: this.endDateStage2, status: this.status2, wrksId: this.wrksId2 },
      { stageNum: this.translations.lbl_stage + ' 3', startDate: this.startDateStage3, endDate: this.endDateStage3, status: this.status3, wrksId: this.wrksId3 },


    ];
  }

  async getTranslatedLabels() {
    try {
      await this.translationService.getTranslatedLabels(this.security.language, this.security.region);
      this.translations = this.translationService.getLabels();
      await this.getLanguages();
      this.checkMateLabel();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }



  /** Input Value Functions */

  async getStatesByCountry() {
    await this.apiService.getStatesFromStore(
      {
        "storeId": this.selectedStore.storeId
      }
    ).then(
      data => {
        this.listState = data;

      });
  }

  async getGuideProfileServices() {
    if (this.security && this.security.guideId) {
      await this.apiService.getGuideProfile({ guideId: this.security.guideId }).then(
        data => {
          this.profileUser = data;


        }).catch(error => {
          this.messageService.add({ key: "tst", severity: 'warn', summary: 'Error: ' + error + "/", detail: " ", life: 3000 });
        });
    }
    //console.log(this.schoolFpgDetail);
    if (this.schoolFpgDetail) {
      this.selectedState = this.listState.find(s => s.id.stateId === this.schoolFpgDetail.schoollAddress.state);
    }
    if (!this.selectedState && this.profileUser) {
      this.selectedState = this.listState.find(s => s.id.stateId === this.security.stateId);
    }
    if (!this.selectedState) {
      this.selectedState = this.listState[0];
    }
    this.getChurches();

  }

  async getChurches() {
    this.listChurchs = [];
    const body = {
      country: this.selectedState.id.countryId,
      state: this.selectedState.id.stateId,
      name: ""
    };

    await this.apiService.getChurchsByCountryState(body).then(
      data => {
        this.listChurchs = data;
        this.listChurchs = this.listChurchs.map((ChurchAdressVO: any) => {
          return {
            ...ChurchAdressVO,
            name: ChurchAdressVO.name + ': ' + ChurchAdressVO.zipCode + ' ' + ChurchAdressVO.street + ' ' + ChurchAdressVO.neight + ' ' + ChurchAdressVO.city + ', ' + ChurchAdressVO.state
          };
        });
        if (this.schoolFpgDetail) {

          this.selectedChurch = this.listChurchs.find(p => p.churchId === this.schoolFpgDetail.schoolFPG.churchId);
        }
      });
  }


  filterChurch(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.listChurchs.length; i++) {
      let church = this.listChurchs[i]; // Original data from service
      if (church.name.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(church);
      }
    }
    this.filteredChurchs = filtered;
  }

  getPeriodToday() {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let period = currentMonth < 7 ? 1 : 2;
    this.selectedYear = currentYear;
    this.selectedPeriod = period;
  }

  onUpdateMinMaxByPeriodYear() {
    // Use the current year if not provided
    const currentYear = new Date().getFullYear();
    const selectedYear = this.selectedYear ?? currentYear;

    // Validate the period, default to 1 if not provided
    const selectedPeriod = this.selectedPeriod === 1 || this.selectedPeriod === 2 ? this.selectedPeriod : 1;

    const { minDate, maxDate } = this.getPeriodDates(selectedYear, selectedPeriod);
    this.minDate = minDate;
    this.maxDate = maxDate;

    // console.debug("year - year:", this.anioPeriod + " " + this.numberPeriodo);
    // console.debug("maxDate:", maxDate);
    // console.debug("minDate:", minDate);
  }

  getPeriodDates(year: number, period: number) {
    let minDate: Date;
    let maxDate: Date;

    if (period === 1) {
      // Periodo 1: Enero (01) a Junio (06)
      minDate = new Date(year, 0, 1); // 1 de enero
      maxDate = new Date(year, 5, 30); // 30 de junio
    } else if (period === 2) {
      // Periodo 2: Julio (07) a Diciembre (12)
      minDate = new Date(year, 6, 1); // 1 de julio
      maxDate = new Date(year, 11, 31); // 31 de diciembre
    } else {
      throw new Error("Periodo inválido. Debe ser 1 o 2.");
    }

    return {
      minDate,
      maxDate
    };
  }

  async getLanguages() {
    const body = {
      storeId: this.selectedStore.storeId,
      language: this.security.language
    }
    this.apiService.getListSpkLangByStoreId(body).then(
      data => {
        this.listLanguage = data;

        if (this.schoolFpgDetail) {
          this.selectedLanguage = this.listLanguage.find(l => l.valueId === this.schoolFpgDetail.schoolFPG.language);
        }
        if (!this.selectedLanguage) {
          this.selectedLanguage = this.listLanguage[0];
        }
      });
  }
  checkMateLabel() {
    if (this.selectedSchoolType != null) {
      if (this.selectedSchoolType.wsId == '04' || this.selectedSchoolType.wsId == '05') {
        this.visibleMateGuide = false;
      } else {
        this.visibleMateGuide = true;
      }
      this.sessNum = this.selectedSchoolType.sesNum;
      this.onSelectInitialTime();
    }
  }

  onSelectInitialTime() {
    let duration: number = + this.epgDuration;
    this.endTime = moment(this.startTime).add(duration, 'm').toDate();
  }

  async getGuidesByStore() {
    const lstStr = [];

    lstStr.push(this.selectedStore.storeId);
    this.listStore.push(this.selectedStore);

    this.listGuidesStore1 = [];
    this.listGuidesStore2 = [];
    await this.apiService.getGuidesByStore({ lstStr: lstStr }).then(
      data => {
        this.listGuidesStore1 = data;
        this.listGuidesStore1 = this.listGuidesStore1.filter(guide => guide.status == 'A' && guide.guiType != 'F');
        this.listGuidesStore1.forEach((element) => {
          if (element.status == 'A' && element.guiType != 'F') {
            this.listGuidesStore2.push(element);
          }
        });
        this.listGuidesStore1 = this.listGuidesStore1.map((guide: any) => {
          return {
            ...guide,
            fullName: guide.name + ' ' + guide.lastName
          };
        });
        this.listGuidesStore2 = this.listGuidesStore2.map((guide: any) => {
          return {
            ...guide,
            fullName: guide.name + ' ' + guide.lastName
          };
        });
        if (this.schoolFpgDetail) {
          this.selectedGuideStore1 = this.listGuidesStore1.find(g => g.guideId === this.schoolFpgDetail.schoolFPG.guideId);
        } else {
        }
        if (this.schoolFpgDetail) {
          this.selectedGuideStore2 = this.listGuidesStore2.find(g => g.guideId === this.schoolFpgDetail.schoolFPG.mateGuideId);
        }
        this.loadDataDetail();
      });
  }



  /** CRUD FUNCTIONS */

  /**
   * The function "saveSchoolFpgConfirmation()" is declared in TypeScript but has no implementation code.
   */
  saveSchoolFpgConfirmation() {
    // Validate Fields 

    if (this.validateAllFields()) {
      this.confirmationService.confirm({
        message: this.translations.lbl_are_you_sure + " " + this.translations.lbl_update + " " + this.translations.lbl_school_prep_guides + "?",
        header: this.translations.lbl_confirm + " " + this.translations.lbl_update,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translations.lbl_yes,
        rejectLabel: this.translations.lbl_no,
        acceptButtonStyleClass: "p-button-success",
        rejectButtonStyleClass: "p-button-info",
        accept: () => {
          this.createSchoolFpg('CU');
        }
      });
    } else {
      this.messageService.add({ severity: 'warn', summary: this.translations.lbl_there_are_missing_values, detail: "", life: 10000 });
    }
  }

  /**
   * This function throws an error indicating that it has not been implemented.
   */
  validateAllFields(): boolean {
    const fields = [
    ];

    return fields.every(field => field != null);
  }


  /**
   * The function "createSchoolFpg" is not implemented and throws an error.
   */
  createSchoolFpg(opt: any) {

    let school: SchoolFpgVO = {
      schoolId: this.schoolFpgDetail != null ? this.schoolFpgDetail.schoolFPG.schoolId : "",
      storeId: this.selectedStore.storeId,
      name: this.selectedName != null ? this.selectedName : null,
      fromTime: this.startTime != null ? this.tovpilUtils.dateToTovpilOnlyTime(this.startTime) : null,
      status: this.schoolFpgDetail != null ? this.schoolFpgDetail.schoolFPG.status : "P",
      guideId: this.selectedGuideStore1 != null ? this.selectedGuideStore1.guideId : "",
      mateGuideId: this.selectedGuideStore2 != null ? this.selectedGuideStore2.guideId : "",
      churchId: this.selectedChurch != null ? this.selectedChurch.churchId : null,
      year: this.selectedYear != null ? this.selectedYear : null,
      period: this.selectedPeriod != null ? this.selectedPeriod : null,
      planedDate: this.planedDate != null ? this.tovpilUtils.dateToTovpilDate(this.planedDate) : null,
      createDate: this.schoolFpgDetail != null && this.schoolFpgDetail.schoolFPG ? this.schoolFpgDetail.schoolFPG.createDate : null,
      language: this.selectedLanguage.valueId,
      wrksId01: this.schoolFpgDetail != null && this.schoolFpgDetail.schoolFPG != null ? this.schoolFpgDetail.schoolFPG.wrksId01 : "",
      wrksId02: this.schoolFpgDetail != null && this.schoolFpgDetail.schoolFPG != null ? this.schoolFpgDetail.schoolFPG.wrksId02 : "",
      wrksId03: this.schoolFpgDetail != null && this.schoolFpgDetail.schoolFPG != null ? this.schoolFpgDetail.schoolFPG.wrksId03 : "",
    }

    let schoolRequest: SchoolFPGWrpVO = {
      schoolFPG: school,
      method: opt == 'D' ? 'DELETE' : this.schoolFpgDetail == null ? 'CREATE' : 'UPDATE',
      language: this.security.language,
      userId: this.security.userId
    }

    this.apiService.crudSchoolFpg(schoolRequest).then(
      data => {

        if (data && data.status.trim() == 'OK') {
          this.messageService.add({ severity: 'success', summary: this.translations.lbl_updated_data, detail: this.translations.lbl_successfully_registered, life: 5000 });
          this.redirectSchoolList();
        } else {
          this.messageService.add({ severity: 'warn', summary: 'ERROR: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'warn', summary: `Error:${this.translations.lbl_update} ${this.translations.lbl_service}: ${error} /`, detail: "Error al Actualizar servicio" + error + "/", life: 3000 });
      });

  }

  deleteSchoolFpg() {
    this.createSchoolFpg('D');
  }
  listDependetLocalStores() {
    //   const body = {
    //     storeId: this.security.storeId,
    //    period: this.selectedPeriod != null ? this.selectedPeriod : "",
    //     year: this.selectedYear != null ? this.selectedYear : ""
    //   };
    this.listStore = [];


    // this.apiService.listDependetLocalStores(body).then(
    //   data => {
    //     this.listStore = data;
    //     if (this.listStore) {
    //       if (this.schoolFpgDetail && this.schoolFpgDetail.schoolFPG) {
    // 
    //         this.selectedStore = this.listStore.find(s => s.storeId === this.schoolFpgDetail.schoolFPG.storeId);
    //       }
    //       if (!this.selectedStore) {
    //         this.selectedStore = this.listStore[0];
    //       }
    //     }
    this.getGuidesByStore();


    //  });
  }

  openSchoolFpgWorkshopDetail(data: any) {
    this.apiService.findWorkShopsDetailByID({
      "wrksId": data.wrksId
    }).then(
      data => {
        let obj = {
          workshop: data,
          eppg: this.schoolFpgDetail,
          security: this.security,
          type: 'S',
          storeIdParam: this.selectedStore.storeId,
          selectedPeriod: this.selectedPeriod
        }
        let queryParamsDetail = {}
        if (this.currentUser && this.currentUser.tokenProfile && this.device) {
          queryParamsDetail = {
            token: this.currentUser.tokenProfile,
            device: this.device
          }
        }
        let navigationExtras: NavigationExtras = {
          queryParams: queryParamsDetail,
          state: JSON.parse(JSON.stringify(obj))
        }
        this.router.navigate(
          ['/guide/workshopsDetail'], navigationExtras);


      });
  }
  
  openSchoolFpgWorkshopAssistence(data: any) {
    this.apiService.findWorkShopsDetailByID({
      "wrksId": data.wrksId
    }).then(
      data => {
        let obj = {
          workshop: data,
          eppg: this.schoolFpgDetail,
          security: this.security,
          view : "schoolfpgDetail"
        }
        let queryParamsDetail = {}
        if (this.currentUser && this.currentUser.tokenProfile && this.device) {
          queryParamsDetail = {
            token: this.currentUser.tokenProfile,
            device: this.device,
            view: 'schoolfpgDetail',
            wrksId: data.wrksId
          }
        }
        let navigationExtras: NavigationExtras = {
          queryParams: queryParamsDetail,
          state: JSON.parse(JSON.stringify(obj))
        }
        this.router.navigate(
          ['secretary/schoolAssistance'], navigationExtras);


      });
    /*let obj = {
      workshop: workshopSel,
      security: this.security
    }
    let queryParamsDetail = {}

    if (this.token && this.device) {

      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    if (workshopSel.f0.serTyp == '16' || workshopSel.f0.serTyp == '17' || workshopSel.f0.serTyp == '18') {
      //Check if service has a school.
      this.router.navigate(['secretary/schoolAssistance'], navigationExtras);
      // else do next

    } else {
      this.router.navigate(['guide/workshopAssistance'], navigationExtras);
    }*/
  }


  /**
    * This function formats a given date string into a specific format using the datePipe module in
    * TypeScript.
    * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
    * "Oct 15, 2021").
    * @returns The function `formatDate` is returning a formatted date string in the format of
    * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
    * format the date. The formatted date string is then returned by the function.
    */
  formatDate(dateString: any) {

    const day = String(dateString.getDate()).padStart(2, '0'); // Get the day and pad it with leading zeros if necessary
    const month = String(dateString.getMonth() + 1).padStart(2, '0'); // Get the month (Note: months are zero-based) and pad it with leading zeros if necessary
    const year = String(dateString.getFullYear()); // Get the year and take the last two digits

    return `${year}-${month}-${day}`;
  }

}
